<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg5 xl4>
            
            <template v-if="!sms_confirm">
              <v-card class="elevation-1">
                <v-toolbar dark color="light-blue darken-3" class="elevation-0">
                  <v-toolbar-title>Регистрация</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>[edoc].cloud</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form ref="reg_start" lazy-validation>
                    <v-text-field 
                      v-model="phone" 
                      :rules="phoneRules" 
                      :error-messages="errors.phone" 
                      prepend-icon="phone" 
                      mask="## (###) ###-##-##" 
                      label="Номер телефона" 
                      type="text"></v-text-field>
                    <v-text-field 
                      v-model="password" 
                      :rules="passwordRules"
                      :error-messages="errors.password"  
                      prepend-icon="lock" 
                      label="Пароль" 
                      type="password"></v-text-field>
                    <v-text-field 
                      v-model="password2" 
                      :rules="passwordRules"
                      :error-messages="errors.password2" 
                      prepend-icon="lock" 
                      label="Подтверждение пароля" 
                      type="password"></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn dark color="light-blue darken-3" @click="submit_reg()">Получить смс-код</v-btn>
                </v-card-actions>
              </v-card>
              <v-card class="elevation-1 mt-3">
                <v-card-text>
                  Уже есть аккаунт? <router-link :to="{name:'auth'}">Авторизироваться</router-link>
                </v-card-text>
              </v-card>
              <v-card class="elevation-1 mt-3">
                <v-card-text>
                  Забыли пароль? <router-link :to="{name:'recover'}">Восстановить</router-link>
                </v-card-text>
              </v-card>
            </template>
            <template v-else>
              <v-card class="elevation-1">
                <v-toolbar dark color="blue darken-3" class="elevation-0">
                  <v-toolbar-title>Завершение регистрации</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>[edoc].cloud</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form ref="reg_confirm" lazy-validation>
                    <v-text-field 
                      v-model="code" 
                      :rules="codeRules" 
                      :error-messages="errors.code" 
                      prepend-icon="sms"
                      mask="####" 
                      label="Код подтверждения"
                      type="text"
                      validate-on-blur></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="submit_confirm()">Зарегистрироваться</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
      phone: '',
      phoneRules: [v => !!v || 'Обязательное поле'],
      password: '',
      password2: '',
      passwordRules: [
        v => !!v || 'Обязательное поле',
        v => v.length >= 6 || 'Минимальная длина пароля 6 символов'
      ],
      code: '',
      codeRules: [
        v => !!v || 'Обязательное поле',
        v => v.length == 4 || 'Код подтверждения - 4 цифры'
      ],
      sms_confirm: false,
      errors: {
        phone: [],
        password: [],
        password2: [],
        code: []
      }
  }),
  methods: {
    submit_reg: function() {

      if (!this.$refs.reg_start.validate()) {
        return
      }

      this.$store
        .dispatch('userReg', {
          phone: this.phone,
          password: this.password,
          password2: this.password2
        })
        .then(response => {
          if (response.data.status == 'OK') {
            this.sms_confirm = true
            this.$nextTick(() => {
              this.$refs.reg_confirm.reset()
            })
          }
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
    },
    submit_confirm: function() {

      if (!this.$refs.reg_confirm.validate()) {
        return
      }

      this.$store
        .dispatch('userRegConfirm', {
          phone: this.phone,
          code: this.code,
          password: this.password
        })
        .then(response => {
          localStorage.setItem('token', response.data.token)
          this.$router.push({ name: 'all_document_list' })
        })
        .catch(error => {
          this.errors = error.response.data.errors
        });
    }
  }
};
</script>